import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import Checkbox from "@material-ui/core/Checkbox";

const UpsellsList = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const serviceOptions = [
		{
			upsellOption: "Snow board training",
			detail: "30 mins",
			price: "$40",
		},
		{
			upsellOption: "Guitar sheet music",
			detail: "Books",
			price: "$25",
		},
		{
			upsellOption: "BMI test",
			detail: "30 mins",
			price: "$40",
		},
		{
			upsellOption: "Guitar sheet music 2",
			detail: "Books",
			price: "$25",
		},
	];

	const [selectedOptions, setSelectedOptions] = useState([]);

	// Adjust to handle multiple selection logic
	const handleCheckboxChange = (event, option) => {
		const currentIndex = selectedOptions.indexOf(option.upsellOption);
		const newSelectedOptions = [...selectedOptions];

		if (currentIndex === -1) {
			newSelectedOptions.push(option.upsellOption);
		} else {
			newSelectedOptions.splice(currentIndex, 1);
		}

		setSelectedOptions(newSelectedOptions);
	};

	return (
		<List>
			{serviceOptions.map((option, index) => (
				<ListItem
					key={index}
					button
					onClick={() => handleCheckboxChange(null, option)}
					classes={{
						root: classes.listItem,
						button: classes.listButton,
						container: classes.listItemContainer,
					}}
					disableGutters
				>
					<ListItemText
						classes={{
							primary: classes.listPrimary,
							secondary: classes.listSecondary,
							multiline: classes.listMultiline,
						}}
						primary={option.upsellOption}
						secondary={
							<>
								<Box mb={3}>{option.detail}</Box>
								<Box color={"#222 !important"} fontWeight={600}>
									{option.price}
								</Box>
							</>
						}
					/>
					<ListItemSecondaryAction>
						<Checkbox
							color="primary"
							edge="end"
							checked={selectedOptions.includes(option.upsellOption)}
							onChange={(event) => handleCheckboxChange(event, option)}
						/>
					</ListItemSecondaryAction>
				</ListItem>
			))}
		</List>
	);
};

UpsellsList.propTypes = {};
export default UpsellsList;
